function parseCsvLine(line) {
  const values = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i += 1) {
    const char = line[i];
    if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === ',' && !inQuotes) {
      values.push(current.trim());
      current = '';
    } else {
      current += char;
    }
  }
  values.push(current.trim());
  return values;
}

/** Parse CSV text into a small preview table for admin review. */
export function parseCsvPreviewTable(csvText, { maxRows = 20, maxCols = 8 } = {}) {
  const text = String(csvText || '').trim();
  if (!text) return null;

  const lines = text.split(/\r?\n/).filter((line) => line.trim());
  if (!lines.length) return null;

  const headerCells = parseCsvLine(lines[0]);
  const columns = headerCells.slice(0, maxCols).map((col) => col || '—');
  const totalCols = headerCells.length;
  const totalRows = Math.max(lines.length - 1, 0);

  const rows = [];
  for (let i = 1; i < lines.length && rows.length < maxRows; i += 1) {
    const cells = parseCsvLine(lines[i]);
    rows.push(columns.map((_, idx) => cells[idx] ?? ''));
  }

  return {
    columns,
    rows,
    truncatedRows: totalRows > maxRows,
    truncatedCols: totalCols > maxCols,
    totalRows,
    totalCols,
  };
}
